import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import App from "./App";

document.documentElement.classList.add("js-ready");
// Hidden fallback still wins fragment navigation (#solution, #problem).
document.getElementById("seo-fallback")?.remove();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
